import { reduceTwo } from "@glideapps/ts-necessities";

export const noAPICapabilities = {
    requestReload: false,
    mutateTables: false,
    queryTables: false,
};

export type APICapabilities = Record<keyof typeof noAPICapabilities, boolean>;

export function combineAPICapabilities(
    caps1: APICapabilities | undefined,
    caps2: APICapabilities | undefined
): APICapabilities {
    return (
        reduceTwo(caps1, caps2, (a, b) => ({
            mutateTables: a.mutateTables && b.mutateTables,
            queryTables: a.queryTables && b.queryTables,
            requestReload: a.requestReload && b.requestReload,
        })) ?? noAPICapabilities
    );
}
